import { useNavigate } from 'react-router-dom';
import { Panel, Typography, PrimaryButton } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './intro-page.css';
import { APP_URLS } from '../routes/paths';
import { APP_TEXT } from '../const/app-text';
import { useErrorContext } from '../components/error';
import { useAuthContext } from '../auth/auth-provider';
import { PageWrapper } from '../components/page-wrapper';
import { PageTracker } from '../components/page-tracker';

const pageText = APP_TEXT.pages.introPage;

const IntroPage = () => {
  const navigate = useNavigate();
  const { userId } = useAuthContext();
  const { bannerError } = useErrorContext();

  return (
    <PageWrapper title={pageText.metaData.title}>
      <PageTracker
        pageName="IntroPage"
        userId={userId}
      />
      <Panel className="introWrapper">
        <div className="introContent">
          <div className="introContentTitle">
            <Typography
              className="title"
              variant="h1.bold"
            >
              {pageText.title}
            </Typography>

            <div className="introContentBody">
              <Typography
                className="body"
                variant="body"
              >
                {pageText.body1}
              </Typography>

              <Typography
                className="subtext"
                variant="body"
              >
                {pageText.body2}
              </Typography>
            </div>
          </div>

          <div className="cardContent">
            {pageText.cards.map((card: any) => (
              <Panel
                key={card.id}
                className="cardPanel"
              >
                <img
                  src={`/assets/${card.icon}`}
                  alt={card.imageAlt}
                  style={{
                    height: '32px',
                    width: 'auto',
                  }}
                />
                <div className="cardPanelBody">
                  <Typography
                    variant="h3.bold"
                    className="typography"
                  >
                    {card.title}
                  </Typography>
                  <Typography variant="body.small">{card.description}</Typography>
                </div>
              </Panel>
            ))}
          </div>

          <Typography
            className="footer"
            variant="body"
          >
            {pageText.footer}
          </Typography>

          <div
            className="floatingActionsSectionScrollSpace"
            style={{
              height: bannerError ? 'var(--error-banner-height)' : '0',
            }}
          ></div>
          <div
            className="floatingActionsSection"
            style={{
              bottom: bannerError ? 'var(--error-banner-height)' : '0',
            }}
          >
            <div className="floatingActionsSectionContainer">
              <PrimaryButton
                className="button"
                aria-label={pageText.continue}
                onClick={() => navigate(APP_URLS.quizProfileSelection())}
              >
                {pageText.continue}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Panel>
    </PageWrapper>
  );
};

export default IntroPage;
